// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"d65e6573","380":"bca2c62b","514":"72848942","542":"d6e9e89e","580":"05f3884b","873":"f48f2f7b","907":"ec2146ff","956":"3d5be85d"}[chunkId] + ".chunk.js";
};